function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L50 0L50 50L0 50L0 0Z",
  id: "typescript_path_1"
}), /*#__PURE__*/React.createElement("clipPath", {
  id: "typescript_mask_1"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#typescript_path_1"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "typescript-1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L50 0L50 50L0 50L0 0Z",
  id: "typescript-1-(Background/Mask)",
  fill: "none",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#typescript_mask_1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M49.1367 31.5367C47.8204 36.4092 45.0684 40.6918 41.3612 43.903C36.9766 47.702 31.2571 50 25 50C11.1929 50 0 38.8071 0 25C0 11.1929 11.1929 0 25 0C38.8071 0 50 11.1929 50 25C50 27.2612 49.7 29.453 49.1367 31.5367Z",
  id: "Vector",
  fill: "#FFFFFF",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(8.115234 15.788086)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.6429 28.1148C10.2807 28.1343 9.90205 28.1434 9.50918 28.1434C4.31836 28.1434 1.43369 24.8996 0 22.4659L4.70615 19.6384C4.70615 19.6384 6.30713 23.0404 9.3082 23.0404C12.3103 23.0404 13.5112 22.0394 13.5112 19.7384C13.5112 16.9363 3.80508 15.9363 2.3041 11.1333C0.803124 6.33026 2.8041 -0.474913 9.80918 0.0261615C14.1867 0.338369 16.649 2.48837 17.8806 4.05673L13.2111 7.43017C12.2102 4.52919 8.10811 4.52919 7.30703 6.93017C6.50703 9.33222 9.208 10.7322 13.4111 12.1332C15.5704 12.8526 17.3071 14.1802 18.4184 15.7485C17.102 20.621 14.35 24.9036 10.6429 28.1148Z",
  transform: "translate(22.60254 0)",
  id: "Vector",
  fill: "#1E1C41",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0L0 5.02109L7.79581 5.02109L7.79581 26.8227L13.4775 26.8227L13.4775 5.02109L21.2732 5.02109L21.2732 0L0 0Z",
  transform: "translate(0 0.7919922)",
  id: "Vector",
  fill: "#1E1C41",
  fillRule: "evenodd",
  stroke: "none"
}))));

var SvgTypescript = function SvgTypescript(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTypescript, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/typescript.3593dd9e.svg";
export { ForwardRef as ReactComponent };